export const colors = {
  blue: '#005570',
  blueDark: '#005570',
  darkOrange: '#bc6d50',
  dullBlue: '#80a3b7',
  gainsboro: '#e5e5e5',
  grayLight: '#f5f5f5',
  grayLightest: '#e9e9e9',
  grayMid: '#bac3bf',
  green: '#8C9B93',
  greenLight: '#94a596',
  greenLightest: '#a0a998',
  grey: '#4C4C4E',
  lightBlue: '#80A3B7',
  lime: '#CCDB2A',
  mistyGreen: '#818054',
  olive: '#94A596',
  orange: '#E4A031',
  orangeBrown: '#896632',
  searchBlue: '#005570',
  teal: '#06909E',
};
